<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
		<FormItem prop="trackName">
			<FormItem prop="trackName">
				<Input style="width: 260px;" type="text" v-model="formInline.OperatorId" :placeholder="$tt('用户名称')">
				<span slot="prepend">{{$tt('用户名称')}}</span>
				</Input>
			</FormItem>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('handleSubmit')" v-if="hasWidgets('search')">{{$tt('查询')}}</Button>
		</FormItem>
		<div style="float: right;">
			<Button type="primary" @click="$emit('show','add')" v-if="hasWidgets('add')">{{$tt('用户添加')}}</Button>
			<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">{{$tt('批量导入')}}</Button> -->
		</div>
	</Form>
</template>

<script>
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					OperatorId: ''
				}
			};
		},
		computed: {
			// pageParam: function() {
			// 	const _this = this;
			// 	const param = {
			// 		OperatorId: _this.formInline.OperatorId
			// 	}
			// 	return param
			// },
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
		},
	}
</script>

<style>
</style>
